import { chain, get } from 'lodash';
import { useCountries } from 'src/composables/countries';

// The address rules moved to `composables/countries`; these delegate so there is one copy. The tax
// rules below have not moved yet.
const {
  countryHasStates,
  countryStates,
  countryStateLabel,
  countryHasPostalCode,
  countryPostalCodeLabel,
} = useCountries();

export default {

  data() {
    return {
      taxCountries: ['AE', 'BE', 'BG', 'CZ', 'DE', 'DK', 'EE', 'IE', 'EL', 'ES',
        'FR', 'HR', 'IT', 'CY', 'LV', 'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL',
        'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'GB',
      ],
      taxStates: { US: ['TX', 'TN'] },

    };
  },
  methods: {

    getValidTaxNumber(taxNumber, country) {
      if (country
      && taxNumber
      && !chain(taxNumber).upperCase().startsWith(country).value()) {
      // Make sure that tax number is prepended with country code
        return country + taxNumber;
      }
      return taxNumber || null;
    }, // getValidTaxNumber()

    stateHasTax(country, state) {
      return chain(this.taxStates).get(country).includes(state).value();
    }, // stateHasTax()

    countryHasTax(country) {
      return this.taxCountries.includes(country);
    }, // countryHasTax()

    countryTaxLabel(country) {
      const taxLabels = this.$tm('common.taxLabels');
      return get(taxLabels, country, taxLabels.default);
    },

    countryTaxHint(country) {
      const taxHints = this.$tm('common.taxHints');
      return get(taxHints, country, taxHints.default);
    },

    countryPostalCodeLabel,

    countryHasPostalCode,

    countryHasStates,

    countryStateLabel,

    countryStates,

  },

};
